import DOMPurify from "dompurify";

// Sanitize any HTML string before injecting via dangerouslySetInnerHTML.
// Preserves safe inline formatting (bold, links, breaks…) and strips scripts/handlers.
export const sanitizeHtml = (html) => ({
  __html: DOMPurify.sanitize(String(html ?? ""), { USE_PROFILES: { html: true } }),
});
